import { t } from "i18next";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import { ISortingGrade } from "../../../utils/data-types";
import "./SortingGradePieChart.scss";

interface DataProps {
  data: ISortingGrade[] | undefined;
  isFirstChart?: boolean;
}

interface PieChartData {
  artikkel: string;
  mengde: number;
}

export const SortingGradePieChart = ({ data, isFirstChart }: DataProps) => {
  let wasteAmount = 0;
  let otherAmount = 0;
  data &&
    data.forEach((entry: ISortingGrade) => {
      if (entry.artikkel === 205) {
        wasteAmount += entry.mengde;
      } else {
        otherAmount += entry.mengde;
      }
    });

  const pieChartData = [
    { artikkel: t("pages.charts.toIncineration"), mengde: wasteAmount },
    { artikkel: t("pages.charts.toRecycling"), mengde: otherAmount },
  ];

  const isWindowSmall = window.innerWidth < 1500;

  const legendFormatter = (value: string) => {
    return <span style={{ color: "#121926" }}>{value}</span>;
  };

  const COLORS = ["#2C5113", "#E0F1D9"];

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <text
          x="50"
          y={isFirstChart || isWindowSmall ? "53%" : "33%"}
          fill="#888"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {data && data.length > 0 && data[0].year}
        </text>

        <Pie
          data={pieChartData}
          dataKey="mengde"
          nameKey="artikkel"
          cx="50%"
          cy={isFirstChart || (!isFirstChart && isWindowSmall) ? "53%" : "33%"}
          outerRadius={100}
          labelLine={false}
          label={({
            cx,
            cy,
            midAngle,
            innerRadius,
            outerRadius,
            percent,
            index,
          }) => {
            if (percent * 100 >= 4.5) {
              const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
              let x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
              const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));

              if (index === 0) {
                x += 20;
              }

              return (
                <text
                  x={x}
                  y={y}
                  fill={index === 0 ? COLORS[1] : COLORS[0]}
                  textAnchor={x > cx ? "start" : "end"}
                  dominantBaseline="central"
                >
                  {`${(percent * 100).toFixed(1)}%`}
                </text>
              );
            } else if (percent * 100 > 0 && percent * 100 < 4.5) {
              const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
              let x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
              const y =
                cy + radius * Math.sin(-midAngle * (Math.PI / 180)) - 17;

              if (index === 0) {
                x += 20;
              }

              return (
                <text
                  x={x}
                  y={y}
                  fill={COLORS[1]}
                  textAnchor={x > cx ? "start" : "end"}
                  dominantBaseline="central"
                >
                  {`${(percent * 100).toFixed(1)}%`}
                </text>
              );
            } else {
              return null;
            }
          }}
        >
          {pieChartData.map((entry: PieChartData, index: number) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[index]}
              style={{ outline: "none" }}
            />
          ))}
        </Pie>
        <Tooltip />
        {(isFirstChart || (!isFirstChart && isWindowSmall)) && (
          <Legend
            formatter={legendFormatter}
            verticalAlign="top"
            iconType="circle"
          />
        )}
      </PieChart>
    </ResponsiveContainer>
  );
};
